// Ship a frontend error to the backend so it lands in the container's persisted
// log — otherwise an FE error only ever exists in the user's browser (exactly the
// gap behind the unseen iPhone "Upload failed"). Fire-and-forget; a failed report
// must never throw or block the UI.
export function reportError(context: string, detail?: unknown): void {
  const d =
    detail instanceof Error
      ? (detail.stack ?? detail.message)
      : detail != null
        ? String(detail)
        : "";
  const message = `${context}${d ? `: ${d}` : ""} | ${navigator.userAgent} | ${location.href}`;
  void fetch("/api/errors", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ message }),
    keepalive: true, // still sends if the page is navigating away / closing
  }).catch(() => {
    /* the error reporter failing is not worth surfacing */
  });
}
